import React, { Component } from "react";
import "./UploadFolderStep3.css";
import TagsUpload from "./TagsUpload";
import UsersEmails from "./UsersEmails";
import Copyright from "../../upload/Copyright";
import { updateMetadata } from "../../../actions/UploadFolderAction";
import { injectIntl } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { fetchUsersToMention } from "../../../api/GroupApi";
import moment from "moment";
import {
  RIGHTS_STATUS_ENABLED,
  RIGHTS_STATUS_UNASSIGNED
} from "../../../constants/rights-constants";

class UploadFolderStep3 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      showSpinnerEmail: true
    };
  }
  componentDidMount() {
    this.fetchUsers();
  }
  handleTags = objectTag => {
    this.props.updateMetadata({
      tags: objectTag.tags
    });
  };

  handleCopyright = ({ copyright }) => {
    const createDate = copyright.createDate
      ? moment(copyright.createDate, ["YYYY-MM-DD", "YYYY/MM/DD"]).format("YYYY-MM-DD")
      : null;
    const dueDate = copyright.dueDate
      ? moment(copyright.dueDate, ["YYYY-MM-DD", "YYYY/MM/DD"]).format("YYYY-MM-DD")
      : null;
    const enabled = copyright.rightsStatus === RIGHTS_STATUS_ENABLED;

    // Compatibilidad con el asistente existente: la persistencia nueva usa
    // rightsStatus/dueDate, pero sus pasos de resumen aún leen las fechas
    // legacy para mostrarlas y enviarlas.
    this.props.updateMetadata({
      rightsStatus: copyright.rightsStatus || RIGHTS_STATUS_UNASSIGNED,
      rightsUiState: copyright.uiState || "unassigned",
      usageRights: enabled,
      dateFrom: createDate ? moment(createDate, "YYYY-MM-DD") : null,
      dateFromFormatted: createDate ? moment(createDate).format("YYYY/MM/DD") : null,
      dateTo: dueDate ? moment(dueDate, "YYYY-MM-DD") : null,
      dateToFormatted: dueDate ? moment(dueDate).format("YYYY/MM/DD") : null,
      // Contrato de cesión (punto 2 de Ricardo). Copyright sólo emite la clave
      // si el usuario tocó el selector, así que `undefined` significa "no lo
      // tocó" y no pisa lo que ya hubiera en el asistente.
      ...(copyright.licenseFile !== undefined
        ? { licenseFile: copyright.licenseFile }
        : {})
    });
  };
  addUserEmail = emails => {
    this.props.updateMetadata({
      usersEmails: emails
    });
  };

  removeUserEmail = email => {
    const { usersEmails } = this.props.uploadFolder;
    if (email) {
      const newList = usersEmails.filter(e => e !== email);
      this.props.updateMetadata({
        usersEmails: newList
      });
    } else {
      usersEmails.pop();
      this.props.updateMetadata({
        usersEmails: usersEmails
      });
    }
  };
  handleOnChangeDescription = e => {
    this.props.updateMetadata({
      tagsProtocol: e.target.value
    });
  };

  fetchUsers = () => {
    this.setState({ showSpinnerEmail: true });
    const { uploadFolder, workclient } = this.props;
    fetchUsersToMention(workclient, uploadFolder.folderselect)
      .then(res => {
        const { adminUsers, operatorUsers } = res.data;
        const usersMentions = [...adminUsers, ...operatorUsers];
        const usersMentionsSorted = usersMentions.sort(
          (firstUser, secondUser) => {
            if (firstUser.name.toLowerCase() < secondUser.name.toLowerCase())
              return -1;
            if (firstUser.name.toLowerCase() === secondUser.name.toLowerCase())
              return 0;
            return 1;
          }
        );
        this.setState({
          users: usersMentionsSorted,
          showSpinnerEmail: false
        });
      })
      .catch(err => {
        this.setState({
          errorFetchingUsers: err,
          showSpinnerEmail: false
        });
      });
  };

  render() {
    const {
      usersEmails,
      tagsProtocol,
      rightsStatus,
      rightsUiState,
      dateFromFormatted,
      dateToFormatted
    } = this.props.uploadFolder;

    const { intl } = this.props;
    const { users, showSpinnerEmail } = this.state;
    const useRightsActive = (this.props.modules || []).some(
      module => module.name === "useRights" && module.activate
    );
    
    return (
      <div
        style={{
          width: "100%",
          height: 450,
          paddingLeft: "5%",
          paddingRight: "5%",
          paddingTop: "1%",
          paddingBottom: "1%",
          overflowY: "auto"
        }}
      >
        <div className="containerUploadFolderStep3">
          <div className="section1">
            <p className="tag_title">
              {intl.formatMessage({ id: "tags_upload_add_tags" })}
            </p>
            <TagsUpload handleTags={this.handleTags} inputEnabled />
            {tagsProtocol && tagsProtocol.length > 0 && (
              <div>
                <p className="tag_title">
                  {intl.formatMessage({ id: "tags_protocol" })}
                </p>
                <div
                  className="tag_protocol_container"
                  dangerouslySetInnerHTML={{ __html: tagsProtocol }}
                />
                {/* <TextArea
                  rows={5}
                  className="tag_protocol_container"
                  placeholder={intl.formatMessage({
                    id: "new_folder_description"
                  })}
                  name="longDescription"
                  maxLength={75}
                  value={tagsProtocol}
                  onChange={this.handleOnChangeDescription}
                  disabled
                /> */}
              </div>
            )}
          </div>
          <div className="section2">
            {useRightsActive && (
              <Copyright
                fillRightsStatus={rightsStatus}
                fillCreateDate={dateFromFormatted
                  ? moment(dateFromFormatted, ["YYYY/MM/DD", "YYYY-MM-DD"]).format("YYYY-MM-DD")
                  : null}
                fillDueDate={dateToFormatted
                  ? moment(dateToFormatted, ["YYYY/MM/DD", "YYYY-MM-DD"]).format("YYYY-MM-DD")
                  : null}
                fillUiState={rightsUiState}
                handleCopyright={this.handleCopyright}
                allowLicenseFile
              />
            )}
            <p className="tag_title">
              {intl.formatMessage({ id: "upload-folder-s4-notify" })}
            </p>
            <UsersEmails
              usersEmails={usersEmails}
              usersEmailAutoComplete={users}
              onRemove={e => {
                this.removeUserEmail(e);
              }}
              onAdd={this.addUserEmail}
              inputEnabled
              showSpinnerEmail={showSpinnerEmail}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    uploadFolder: state.uploadFolder,
    workclient: state.client.data ? state.client.data._id : null,
    modules: state.client.data ? state.client.data.modules : []
  };
};

const mapDispatchToProps = {
  updateMetadata
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(UploadFolderStep3))
);
